module.exports = __webpack_public_path__ + "static/media/31JFA9.862f8c1d.jpg";